import { render, staticRenderFns } from "./ThreeStepsSection.vue?vue&type=template&id=20ce1d98&scoped=true&"
import script from "./ThreeStepsSection.vue?vue&type=script&lang=js&"
export * from "./ThreeStepsSection.vue?vue&type=script&lang=js&"
import style0 from "./ThreeStepsSection.vue?vue&type=style&index=0&id=20ce1d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce1d98",
  null
  
)

export default component.exports